import { useEffect } from 'react';
import { Provider } from 'react-redux';

import store from '@/state/store';
import { hydrateCart } from '@/features/cart/cart-slice';
import CartSheet from '@/components/Cart/CartSheet';
import CartToast from '@/components/Cart/CartToast';
import type { PayPalCheckoutItem } from '@/components/PayPalButton/PayPalForm';

const CART_STORAGE_KEY = `setsl-cart-v1`;

const CartPersistence = () => {
  useEffect(() => {
    try {
      const raw = localStorage.getItem(CART_STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw) as PayPalCheckoutItem[];
        if (Array.isArray(parsed)) {
          const safe = parsed
            .filter((item) => Boolean(item?.hostedButtonId && item?.title))
            .map((item) => ({
              ...item,
              quantity: Math.max(1, item.quantity || 1),
            }));
          store.dispatch(hydrateCart(safe));
        }
      }
    } catch {
      // ignore malformed localStorage data
    }

    const unsubscribe = store.subscribe(() => {
      localStorage.setItem(
        CART_STORAGE_KEY,
        JSON.stringify(store.getState().cart.items),
      );
    });

    return unsubscribe;
  }, []);

  return null;
};

const wrapWithProvider = ({ element }: any) => (
  <Provider store={store}>
    <CartPersistence />
    <CartSheet />
    <CartToast />
    {element}
  </Provider>
);

export default wrapWithProvider;
